import React from 'react'
import { Link, createBrowserRouter } from 'react-router-dom'
import ProtectedRoutes from './ProtectedRoutes'
import AuthLayout from '../pages/Auth'
// import AuthLogin from '../pages/Auth/Login'
import LoginIndex from '../pages/Auth/Login'
import AuthRegister from '../pages/Auth/Register'
import AuthForgotPassword from '../pages/Auth/ForgotPassword'

// import HomeElement from './HomeElement'
import Setting from '../pages/Setting'
import FAQLayout from '../pages/Faq'
// import Questions from '../pages/Faq/Questions'
import Question from '../pages/Faq/Question'
import ContactUs from '../pages/ContactUs'
import ErrorBoundary from '../components/ErrorBoundary'
import MainContent from '../pages/ChatBoat/MainContent'
import SideBarLayout from '../Layout/SidebarLayout'
import HomeLayout from '../Layout/HomeLayout'
import HomeIndex from '../pages/Home'

import NewChat from '../pages/NewChat/NewChat'
import Editor from '../pages/ChatBoat/MainContent/editor/Editor'
import NewChatQuestion from '../pages/NewChat/NewChatQuestion'
import ManyCategories from '../pages/ManyCategories'
// import NewChat from '../pages/NewChat/NewChat'
import ResetPassword from '../pages/Auth/ResetPassword'
import ResetPassowrdByOTP from '../pages/Auth/resetPasswordByOTP/ResetPasswordByOTP'
import ChangePasswordDialogWithoutCurrentPassword from '../components/shared/Dialogs/ResetPassword'

import SharelinkLayout from '../Layout/SharelinkLayout'
import SharechatIndex from '../pages/ShareChat'
import DownloadButtonDialog from '../components/shared/Dialogs/DownloadData'
import PaymentSuccessfulDialog from '../components/shared/Dialogs/PaymentSuccessfull'
import PrivacyAndTerms from '../pages/Auth/PrivacyAndTerms/index'

import { AuthProvider } from '../contexts/AuthContext'
import Verifier from '../pages/NewChat/Verifier'
import { LinkedInCallback } from 'react-linkedin-login-oauth2'
import MaintenancePage from '../pages/Maintenance'
const AppRoutes = createBrowserRouter([
  {
    element: (
      <AuthProvider>
        <HomeLayout />
      </AuthProvider>
    ), // Define a HomeLayout for the root path
    errorElement: <ErrorBoundary />,

    children: [
      {
        path: '/',
        element: <HomeIndex />,
        errorElement: <ErrorBoundary />,
      },
      {
        element: <ProtectedRoutes />,
        children: [
          {
            element: <FAQLayout />,
            errorElement: <ErrorBoundary />,
            children: [
              {
                path: '/faq/need-help-with-a-billing-issue',
                element: <Question />,
              },
            ],
          },
          {
            path: 'settings',
            element: <Setting />,
            handle: {
              crumb: () => <Link to='/settings'>Setting</Link>,
            },
          },
        ],
      },
      {
        path: 'contact-us',
        element: <ContactUs />,
      },
      // {
      //   path: 'maintenance',
      //   element: <MaintenancePage />,
      // },
      {
        element: <ProtectedRoutes />,
        children: [
          {
            element: <SideBarLayout />, // Use SidebarLayout for /sidebar and its children
            errorElement: <ErrorBoundary />,
            children: [
              {
                path: '/NewChatQuestion',
                element: <NewChatQuestion />,
              },
              {
                path: '/NewChatQuestion/:question',
                element: <NewChatQuestion />,
              },
              {
                path: '/many-categories/:category',
                element: <ManyCategories />,
              },
              {
                path: '/MainContent/:id',
                element: <MainContent />,
              },
              // {
              //   path: '/ShareChat/:id',
              //   element: <ShareChat />,
              // },
              {
                path: '/PaymentSuccessfull',
                element: <PaymentSuccessfulDialog />,
              },
              {
                path: '/NewChat',
                element: <NewChat />,
              },
              {
                path: '/NewChat/:id',
                element: <NewChat />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    element: <AuthLayout />, // Under /auth, use AuthLayout
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '/auth/login',
        element: <LoginIndex />,
      },
      // {
      //   path: '/EmailVerification',
      //   element: <EmailVerification />,
      // },
      {
        path: '/auth/register',
        element: <AuthRegister />,
      },
      {
        path: '/auth/privacy-terms',
        element: <PrivacyAndTerms />,
      },
      {
        path: '/auth/forgot-password',
        element: <AuthForgotPassword />,
      },
      {
        path: '/auth/reset-password-link/:email',
        element: <ResetPassword />,
      },
      {
        path: '/auth/reset-password',
        element: <ChangePasswordDialogWithoutCurrentPassword />,
      },
      {
        path: '/auth/reset-password-by-otp',
        element: <ResetPassowrdByOTP />,
      },
      {
        path: '/auth/download-file',
        element: <DownloadButtonDialog />,
      },
    ],
  },
  {
    element: <ProtectedRoutes />,
    children: [
      {
        path: '/editor',
        element: <Editor />,
      },
      {
        path: '/editor/:id',
        element: <Editor />,
      },
      {
        path: '/verifier',
        element: <Verifier />,
      },
      {
        path: '/verifier/:id',
        element: <Verifier />,
      },
    ],
  },
  {
    element: <SharelinkLayout />,
    errorElement: <ErrorBoundary />,

    children: [
      {
        path: '/ShareChat/:id',
        element: <SharechatIndex />,
      },
    ],
  },
  {
    path: '/ShareChat/:id',
    element: <SharechatIndex />,
  },
  {
    path: '/linkedin',
    element: <LinkedInCallback />,
  },
  {
    path: '*',
    element: <ErrorBoundary />,
  },
])

export default AppRoutes
